// packages
import SuggestionSelectorField, {
  DEFAULT_THEME
} from './SuggestionSelectorField';

export { DEFAULT_THEME };

export default SuggestionSelectorField;
